module.exports = __webpack_public_path__ + "img/aef092d3f64ebc6168b244605762aa6a.png";